const STORAGE_VERSION = "v1"
const STORAGE_PREFIX = "gl-settings-sections"

// window.localStorage property ACCESS itself throws SecurityError in some
// privacy modes (Chrome "Block all cookies", some embedded webviews) — before
// any getItem/setItem guard can run. Resolve the storage object through this
// so callers get null instead of a throw, and navigation degrades to
// session-only (everything expanded) rather than dead toggles.
export function safeLocalStorage() {
  try {
    return window.localStorage
  } catch {
    return null
  }
}

export function settingsNavigationStorageKey({ host, userId }) {
  return `${STORAGE_PREFIX}:${STORAGE_VERSION}:${host}:${userId}`
}

export function readExpandedSettingsSections({ storage, key, allowedIds }) {
  if (!storage) return []
  try {
    const parsed = JSON.parse(storage.getItem(key) || "[]")
    if (!Array.isArray(parsed)) return []

    return [...new Set(parsed)].filter((id) => allowedIds.includes(id))
  } catch {
    return []
  }
}

export function writeExpandedSettingsSections({ storage, key, expandedIds }) {
  if (!storage) return
  try {
    storage.setItem(key, JSON.stringify([...new Set(expandedIds)]))
  } catch {
    // Browser privacy settings and exhausted quotas must not break navigation.
  }
}
